<template>
  <div>
    <v-menu
      ref="rangeDate"
      :close-on-content-click="false"
      v-model="rangeDateMenu"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :return-value.sync="options"
      :rules="rules"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          dense
          outlined
          clearable
          readonly
          :label="label"
          :placeholder="'请选择日期范围'"
          v-model="dateRangeText"
          append-icon="mdi-calendar"
          v-on="on"
          :rules="rules"
          :disabled="disabled"
        />
      </template>
      <v-date-picker locale="zh-cn" range v-model="options" no-title scrollable>
        <v-spacer />
        <v-btn text color="primary" @click="rangeDateMenu = false">取消</v-btn>
        <v-btn text color="primary" @click="$refs.rangeDate.save(options)" :disabled="btnDisable"
          >确定</v-btn
        >
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'DateRange',
  props: {
    value: {
      type: Array,
      default: []
    },
    label: {
      type: String,
      default :'日期范围'
    },
    rules: {
      type: Array
    },
    disabled: {
      type:Boolean,
      default:false
    }
  },
  data() {
    return { rangeDateMenu: false, rangeDate: [] }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  computed: {
    dateRangeText:{
      get: function () {
        return this.options.join(' ~ ')
      },
      set: function (val) {
        if(!val){
          this.options = [];
        }
      },
    },
    options: {
      get: function () {
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        if(val && val.length > 1){
          val.sort();
        }
        this.$emit('modify', val) //通过$emit触发父组件
      },
    },
    btnDisable(){
      return this.options.length < 2;
    }
  },

}
</script>